import packageMetadata from "../../package.json";

export const APP_VERSION = packageMetadata.version;
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
